import React, { useEffect, useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import useOutSideClick from "../../common/useOutSideClick";
import styled from "styled-components";
import VersionModalContainer from "../VersionModalContainer";
import Select from 'react-select';
import { ElevatorSharp } from "@mui/icons-material";

function PCVerModal({ title, version, onClose, children, versionSetup }) {
  const modalRef = useRef(null)
  const handleClose = () => {
    onClose?.();
  };
  const [currentVersion, setCurrentVersion] = useState(0);

  useEffect(() => {
    // Mount 될때만 실행된다.
    if(typeof version === 'undefined'){
      version = [];
    }else{
      setCurrentVersion(version.length)
    }
    
    const $body = document.querySelector("body");
    const overflow = $body.style.overflow;
    $body.style.overflow = "hidden";
    return () => {
    	$body.style.overflow = overflow
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        const hasOpenSelectModal = document.querySelector('.in_select_modal') !== null;
        if (!hasOpenSelectModal) {
          onClose?.();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  useEffect(() => {
    // Mount 될때만 실행된다.
    setCurrentVersion(version.length)
  }, [version]);
  
  useEffect(() => {
    // Mount 될때만 실행된다.
    versionSetup(currentVersion);
  }, [currentVersion]);

  const onSelectChange = (value) => {
    setCurrentVersion(value);
  };

  useOutSideClick(modalRef, handleClose);

  return (
    <VersionModalContainer>
      <Overlay>
        <ModalWrap ref={modalRef} className="in_modal">
          <div style={ { display: 'flow-root' } }>
            <div style={{ float: 'left', fontSize: '26px', fontWeight: 'bold', padding: '10px', paddingLeft: '20px', paddingTop: '12px' }}>
              {title}
            </div>
            {typeof version !== 'undefined' && version.length > 0? 
            <div style={{ float: 'right', fontWeight: 'bold', padding: '10px', paddingLeft: '20px', paddingTop: '12px' }}>
              <Select className="menu-modal-version-select" placeholder="Version" onChange={(e) => onSelectChange(e.value)} value={version.filter(function (option) { return option.value === currentVersion;  })} options={version} />
            </div>
            :
            <></>
            }
          </div> 
          <Contents>
            {children}
          </Contents>
        </ModalWrap>
      </Overlay>
    </VersionModalContainer>
  );
}

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 15;
`;

const ModalWrap = styled.div`
  max-width: 1025px;
  height: fit-content;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Contents = styled.div`
  margin: 0px;
  h1 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 60px;
  }
  img {
    margin-top: 60px;
    width: 300px;
  }
`;
const Button = styled.button`
  font-size: 14px;
  padding: 10px 20px;
  border: none;
  background-color: #ababab;
  border-radius: 10px;
  color: white;
  font-style: italic;
  font-weight: 200;
  cursor: pointer;
  &:hover {
    background-color: #898989;
  }
`;
export default PCVerModal;
